$(function () {
    // Get current SKU
    const current_sku = $('input[type=hidden]#hidden-product-sku').val();
    const product_type = $('input[type=hidden]#hidden-product-type').val();
    const product_is_ready_to_ship = $('input[type=hidden]#hidden-ready-to-ship-enabled').val();
    const is_rtw = $('input[type=hidden]#hidden-is-rtw').val();
    const have_active_swatch = $('.active-swatch');

function getColorFromUrl() {
    const lastClickedColor = localStorage.getItem('lastClickedColor');
    if (lastClickedColor) {
        console.log('Couleur trouvée dans localStorage:', lastClickedColor);
        return lastClickedColor;
    }

    const urlParams = new URLSearchParams(window.location.search);
    const colorParam = urlParams.get('color');
    if (colorParam) {
        console.log('Couleur trouvée dans URL params:', colorParam);
        return colorParam;
    }

    // 3. Enfin, extraire depuis le chemin (pour les MTO)
    const currentPath = window.location.pathname;
    const pathParts = currentPath.split('/');
    const productSlug = pathParts[pathParts.length - 1]; 

    if (productSlug && productSlug.includes('-')) {
        const parts = productSlug.split('-');
        if (parts.length >= 2) {
            const potentialColor = parts.slice(1).join('-');
            console.log('Couleur trouvée dans le chemin:', potentialColor);
            return potentialColor;
        }
    }

    console.log('Aucune couleur trouvée');
    return null;
}

    function checkColorMatching(urlColor) {
        if (!urlColor) return null;

        const baseLower = urlColor.toLowerCase();
        let matchedSwatch = null;

        $('.swatch-element').each(function () {
            const swatchColor = $(this).attr('data-colorname-value').toLowerCase();
            if (swatchColor === baseLower) {
                matchedSwatch = $(this);
                return false; 
            }
        });
        if (!matchedSwatch) {
            const colorJsonUrl = document.getElementById('color-json-url')?.value || '/assets/amsale_colors_full.json';

            $.ajax({
                url: colorJsonUrl,
                dataType: 'json',
                async: false,
                success: function (colorDictionary) {

                    const baseEntry = colorDictionary[baseLower];

                    if (baseEntry && Array.isArray(baseEntry.base)) {
                        $('.swatch-element').each(function () {
                            const swatchValue = $(this).attr('data-colorname-value').toLowerCase();

                            if (baseEntry.base.some(baseColor =>
                                swatchValue.includes(baseColor.toLowerCase()))) {
                                matchedSwatch = $(this);
                                return false; 
                            }
                        });
                    }

                    if (!matchedSwatch) {
                        for (const [colorKey, colorEntry] of Object.entries(colorDictionary)) {
                            if (Array.isArray(colorEntry.base) &&
                                colorEntry.base.some(b => b.toLowerCase() === baseLower)) {

                                $('.swatch-element').each(function () {
                                    const swatchValue = $(this).attr('data-colorname-value').toLowerCase();
                                    if (swatchValue === colorKey.toLowerCase() ||
                                        swatchValue.includes(colorKey.toLowerCase())) {
                                        matchedSwatch = $(this);
                                        return false; 
                                    }
                                });

                                if (matchedSwatch) break;
                            }
                        }
                    }
                }
            });
        }

        return matchedSwatch;
    }

    function getMatchingSwatches(baseColor) {
        if (!baseColor) return [];

        const baseLower = baseColor.toLowerCase();
        const exact = [];
        const soft = [];
        const availableSwatches = [];
        $('.swatch-element').each(function () {
            availableSwatches.push({
                element: $(this),
                value: $(this).attr('data-colorname-value').toLowerCase(),
                name: $(this).attr('data-value').toLowerCase()
            });
        });


        let colorJsonUrl = '/assets/amsale_colors_full.json';
        const colorJsonElement = document.getElementById('color-json-url');
        colorJsonUrl = colorJsonElement.value;
        $.ajax({
            url: colorJsonUrl,
            dataType: 'json',
            async: false,
            success: function (colorDictionary) {
                const baseEntry = colorDictionary[baseLower];

                if (baseEntry && Array.isArray(baseEntry.base)) {

                    for (const swatch of availableSwatches) {
                        if (baseEntry.base.some(baseColor =>
                            swatch.value.includes(baseColor.toLowerCase()) ||
                            swatch.name.includes(baseColor.toLowerCase()))) {
                            soft.push(swatch.element);
                        }
                    }
                }

                if (soft.length === 0) {

                    for (const [colorKey, colorEntry] of Object.entries(colorDictionary)) {
                        if (Array.isArray(colorEntry.base)) {
                            // Vérifier si la couleur de l'URL est une des couleurs de base de cette entrée
                            if (colorEntry.base.some(b => b.toLowerCase() === baseLower ||
                                b.toLowerCase().includes(baseLower) ||
                                baseLower.includes(b.toLowerCase()))) {

                                for (const swatch of availableSwatches) {
                                    if (swatch.value === colorKey || swatch.name === colorKey ||
                                        swatch.value.includes(colorKey) || swatch.name.includes(colorKey)) {
                                        soft.push(swatch.element);
                                    }
                                }
                            }
                        }
                    }
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.error("Erreur lors du chargement du dictionnaire de couleurs:", textStatus, errorThrown);
            }
        });

        // Appliquer les correspondances trouvées
        applyMatchingColor([...exact, ...soft]);


        return [...exact, ...soft];
    }


    function applyMatchingColor(matches) {
        if (matches && matches.length > 0) {
            if ($firstSwatch.hasClass('active-swatch')) {
                $firstSwatch.removeClass('active-swatch');
            }
            matches[0].addClass('active-swatch').find('input').prop('checked', true).change();
            const colorTitle = matches[0].attr('data-colorname-value');
            document.querySelector('#selectedColor').textContent = colorTitle;
        } else {
            $('.swatch-element').first().addClass('active-swatch').find('input').prop('checked', true).change();
        }
    }



    // Initialize Options Object
    let selected_options = {
        "sku": '',
        "dress_size": '',
        "dress_length": '',
        "color": ""
    };
    const urlColor = getColorFromUrl();
    if (urlColor && !have_active_swatch.length) {
        selected_options.color = urlColor;
    }
    $(document).ready(function () {
        const urlColor = getColorFromUrl();
        if (urlColor) {
            setTimeout(function () {
                const matchedSwatch = checkColorMatching(urlColor);

                if (matchedSwatch) {

                    const redirectLink = matchedSwatch.attr('data-rts-redirect-link');
                    if (redirectLink && window.location.pathname !== redirectLink) {

                        const resetOptions = {
                            sku: '',
                            dress_size: '',
                            dress_length: '',
                            color: matchedSwatch.attr('data-colorname-value')
                        };

                        sessionStorage.setItem('selected_options', JSON.stringify(resetOptions));

                        window.location.href = redirectLink;
                    } else {
                        $('.swatch-element').removeClass('active-swatch');
                        setSwatchSelectValue(matchedSwatch.attr('data-colorname-value'));
                        matchedSwatch.addClass('active-swatch')
                            .find('input')
                            .prop('checked', true)
                            .change();

                        if (document.querySelector('#selectedColor')) {
                            document.querySelector('#selectedColor').textContent =
                                matchedSwatch.attr('data-colorname-value');
                        }

                        if (is_rtw == 'true') {
                            fetchProductAndInventoryData(matchedSwatch.attr('data-colorname-value'));
                        }
                    }
                }
            }, 500); 
        }
    });
    window.scrollTo(0, 0);
    $(window).on('load', function () {
        window.scrollTo(0, 0);
    });



    if (product_is_ready_to_ship == 'true' && product_type == 'dress') {
        $('.product-select--dress-length select').prop('disabled', true);
    }

    const singleOptionSelector = document.querySelector('select[aria-label="Dress Length"]');
    const targetElement = document.querySelector('.form-control.product-form__selects.product-select--dress-length.product-select--RTS');

    if (singleOptionSelector && singleOptionSelector.options.length <= 1) {
        targetElement.style.display = 'none';
    }
    let $firstSwatch = $('.swatch-element').first();

    if (!have_active_swatch.length) {
        if (selected_options.color != '') {
            getMatchingSwatches(selected_options.color);
        } else {
            $firstSwatch.addClass('active-swatch');
            let redirectLink = $firstSwatch.attr('data-rts-redirect-link');
            if (redirectLink && window.location.href !== redirectLink) {
                if (!sessionStorage.getItem('redirected')) {
                    sessionStorage.setItem('redirected', 'true');
                    window.location = redirectLink;
                } else {
                    sessionStorage.removeItem('redirected');
                }
            }
        }
    }

    // Check to see if SessionStorage exists
    const session_exists = sessionStorage.getItem("selected_options");
    if (session_exists && (current_sku == JSON.parse(session_exists).sku)) {
        selected_options.sku = JSON.parse(session_exists).sku;
        selected_options.dress_size = JSON.parse(session_exists).dress_size;
        selected_options.dress_length = JSON.parse(session_exists).dress_length;
        selected_options.color = JSON.parse(session_exists).color;
        // let $firstSwatch = $('.swatch-element').first();

        // if(!have_active_swatch.length){
        // if (selected_options.color != '') {
        //     if($firstSwatch.hasClass('active-swatch')){
        //         $firstSwatch.removeClass('active-swatch');

        //     }
        //     let $selectedSwatch = $('.swatch-element').filter(function () {
        //         return $(this).attr('data-colorname-value').toLowerCase() === selected_options.color.toLowerCase();
        //     });

        //     if ($selectedSwatch.length) {
        //         $selectedSwatch.addClass('active-swatch').find('input').prop('checked', true).change();
        //     } else {
        //         $('.swatch-element').first().addClass('active-swatch').find('input').prop('checked', true).change();
        //     }
        // } else {
        //     $firstSwatch.addClass('active-swatch');
        //     let redirectLink = $firstSwatch.attr('data-rts-redirect-link');

        //     if (redirectLink && window.location.href !== redirectLink) {
        //         if (!sessionStorage.getItem('redirected')) {
        //             sessionStorage.setItem('redirected', 'true'); 
        //             window.location = redirectLink;
        //         } else {
        //             sessionStorage.removeItem('redirected'); 
        //         }
        //     }
        // }
        // }




        if (selected_options.dress_size != '') {
            const size_select = $('.infinite-option-size-select select').length > 0 ? $('.infinite-option-size-select select') : $('.product-select--size select');

            if (product_is_ready_to_ship == 'true' && product_type == 'dress') {
                // DO NOTHING
                // For Ready-to-Ship products of type Dress we don't want the reapply the selected Size
                // We only want to do it if we are in the Dress-by-Color type or any other Non-Ready-to-Ship Products
            } else {
                size_select.val(selected_options.dress_size);
            }

            // If dress-by-color Product we set the custom dropdown selected value
            if (product_type == 'dress-by-color') {
                $('.custom-dropdown .selected span').text(selected_options.dress_size);
            }
        }

        if (selected_options.dress_length != '') {
            $('.product-select--dress-length select').val(selected_options.dress_length);
        }

        // Set variant ID if there was a page load or reload
        setVariantID(selected_options.dress_size, selected_options.dress_length);
        handleEnableAddToCart();
    } else {
        // Initialize SessionStorage
        selected_options.sku = current_sku;
        sessionStorage.setItem("selected_options", JSON.stringify(selected_options));
        handleEnableAddToCart();
    }

    // Init Tooltips
    if ($('.colorSelector').length > 0 || $('.exclusive-readonly').length > 0) {
        $('.tooltip').tooltipster({
            theme: 'tooltipster-noir',
            maxWidth: 250,
            animation: 'grow',
        });
    }

    if ($('.product-template__container').length > 0) {

        var alternatePaymentSliderOption = {
            vertical: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
            infinite: true,
            dots: false,
            arrows: false,
            autoplay: true,
            speed: 2000,
            adaptiveHeight: true

        };

        var slider = $('.alternate-payments-slider').slick(alternatePaymentSliderOption);

        // Thumbnail slider
        var slickOptions = {
            vertical: true,
            verticalSwiping: false,
            centerMode: false,
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: false,
            arrows: false,

        };

        // Init slider
        var slider = $('.thmb-slider').slick(slickOptions);
        let isSliding = false;

        var slickOptionsProductMain = {
            centerMode: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: false,
        };

        // Init slider
        var sliderProduct = $('.slider-main').slick(slickOptionsProductMain);
        // Feature image Slider
        var slickOptionsMain = {
            centerMode: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: false,
        };

        // Init slider
        var sliderMain = $('.image-main').slick(slickOptionsMain);
        sliderMain.find('.slick-slide').attr('aria-hidden', 'false');
        function toggleSlickBasedOnScreenSize() {
            if ($(window).width() > 992) {
                // If screen size is greater than 992px, unslick
                if ($('.image-main').hasClass('slick-initialized')) {
                    $('.image-main').slick('unslick');  // Unslick the slider
                }
            } else {
                // If screen size is 992px or less, initialize slick
                if (!$('.image-main').hasClass('slick-initialized')) {
                    $('.image-main').slick(slickOptionsMain);  // Reinitialize the slider
                }
            }
        }

        // Initial check
        toggleSlickBasedOnScreenSize();

        // Check on window resize
        $(window).on('resize', function () {
            toggleSlickBasedOnScreenSize();
        });

        // Custom slider buttons event
        $('.control-down').on('click', function () {
            if (isSliding) {
                return;
            }

            slider.slick('next');

            sliderMain.slick('next');
            sliderProduct.slick('next');
        });

        $('.control-up').on('click', function () {
            if (isSliding) {
                return;
            }

            slider.slick('prev');
            sliderMain.slick('prev');
            sliderProduct.slick('prev');
        });

        $('.prev-btn').on('click', function () {
            if (isSliding) {
                return;
            }

            sliderMain.slick('prev');
            sliderProduct.slick('prev');
        });

        $('.next-btn').on('click', function () {
            if (isSliding) {
                return;
            }

            sliderMain.slick('next');
            sliderProduct.slick('next');
        });

        slider.on('beforeChange', function () {
            isSliding = true;
        });

        sliderMain.on('beforeChange', function () {
            isSliding = true;
        });
        sliderProduct.on('beforeChange', function () {
            isSliding = true;
        });
        slider.on('afterChange', function (event, slick, currentSlide) {
            isSliding = false;
            setSliderDotActive(currentSlide);
            slider.slick('slickGoTo', currentSlide);
        });

        sliderMain.on('afterChange', function (event, slick, currentSlide) {
            isSliding = false;
            setSliderDotActive(currentSlide);
            sliderMain.slick('slickGoTo', currentSlide);
        });
        sliderProduct.on('afterChange', function (event, slick, currentSlide) {
            isSliding = false;
            setSliderDotActive(currentSlide);
            sliderProduct.slick('slickGoTo', currentSlide);
        });

        $('.thmb').on('click', function () {
            if (isSliding) {
                return;
            }

            slider.slick('slickGoTo', parseInt($(this).attr('data-slide-index')));
            sliderMain.slick('slickGoTo', parseInt($(this).attr('data-slide-index')));
            sliderProduct.slick('slickGoTo', parseInt($(this).attr('data-slide-index')));
        });

        // If the user selects a swatch and if product images have Ghost color dresses
        // we activate the slider to show that colored dress
        var all_slider_thumbs = $('.thmb-slider .thmb');
        var swatch = {
            elements: $('.swatch-element'),
        };
        swatch.elements.on('click keyup', function (e) {
            if (e.type === 'click' || (e.type === 'keyup' && e.keyCode === 13)) {
                const selected_swatch = $(this).attr('data-colorname-value').toLowerCase();
                swatch.elements.each(function () {
                    $(this).removeClass('active-swatch');
                });

                // Reset selected options
                selected_options.dress_size = "";
                selected_options.dress_length = "";
                selected_options.color = selected_swatch;

                sessionStorage.setItem("selected_options", JSON.stringify(selected_options));
                handleEnableAddToCart();

                // Reset size & length selections
                $('.product-select--size select').val('').trigger('change');
                $('.product-select--dress-length select').val('').trigger('change');
                $('.custom-dropdown .selected span.current-selected-value').text('');

                // Fetch product & inventory data for the selected color
                if (is_rtw == 'true') {
                    fetchProductAndInventoryData(selected_swatch);
                }

                $('.swatch-element').removeClass('active-swatch');

                $(this).addClass('active-swatch');

                let results = all_slider_thumbs.filter(function () {
                    return $(this).data("color") && $(this).data("color") === selected_swatch;
                });

                if (results.length > 0) {
                    results.first().click();
                }

                // If Master Product is of type Ready-to-Ship, redirect
                if (product_is_ready_to_ship === 'true') {
                    selected_options = { "sku": '', "dress_size": '', "dress_length": '', "color": "" };
                    sessionStorage.setItem("selected_options", JSON.stringify(selected_options));
                    window.location = $(this).attr('data-rts-redirect-link');
                }
            }
        });
        // Zoom effect


        // Handle Quantity input Add/Substract events
        const quantity_input = $('input.product-form__qty');
        $('button.quantity-btn').on('click', function (e) {
            e.preventDefault();
            let current_quantity = quantity_input.val();

            if ($(this).hasClass('add-qty')) {
                current_quantity++;
            } else {
                current_quantity--;
            }
            // Make sure quantity is not zero or less
            if (current_quantity <= 0) {
                current_quantity = 1;
            }

            quantity_input.val(current_quantity);

            return false;
        });

        let is_boldmetrics = ($('input[type=hidden]#hidden-product-boldmetrics-enabled').val() === 'true');
        if ($('.size-chart-link-popup').length > 0) {
            // Init open Size guide modal on appended Size guide link
            $('.size-chart-link-popup').magnificPopup({
                type: 'inline',
                midClick: true
            });

            if (is_boldmetrics) {
                // if true we add event listener for click on appended Fit check link
                $('.fit-link-modal').on('click', function (e) {
                    e.preventDefault();
                    $('.boldmetrics-ssc-button, #ssc-boldmetrics-activator').click();
                    return false;
                });
            }
        }

        // -------------- Delivery Date Service ------------------
        const collectionName = $('input[type=hidden]#hidden-product-collection').val();

        $(document).ready(function () {

            $.ajax({
                url: 'https://store.b2b.amsale.com/delivery_date_check/' + collectionName + '?platform=b2c',
                context: document.body,
                success: function (data) {
                    var currentDate = new Date(data.value.toString());
                    var formattedDate = moment.utc(currentDate).format("L");
                    const hidden_eta_input = $('#hidden-product-estimated-date');
                    const is_holiday = $('.estimated-delivery-date.is-holiday-date').length > 0;
                    const eta_date_element = $('.estimated-delivery-date p#delivery_service_desc');
                    eta_date_element.attr('data-mto-date', formattedDate);

                    if (!is_holiday) {
                        eta_date_element.find('span.delivery-date').text(formattedDate);
                        hidden_eta_input.val(eta_date_element.data().mtoDate);
                    } else {
                        hidden_eta_input.val(eta_date_element.data().holidayDate);
                    }
                },
                error: function (msg) {
                    console.log('An error occured with the Delivery Date Endpoint AJAX call');
                    console.log('status', msg.status);
                    console.log('statusText', msg.statusText);
                }
            });
        });

        // Add to Cart Submit Click Handler
        $('button[type=submit].product-form__cart-submit').on('click', function (e) {
            // Color
            if ($('.colorSelector').length > 0) {
                if ($('.swatch-element.active-swatch').length <= 0) {
                    e.preventDefault();
                    displayUserFeedbackMessage('error', 'Color missing', 'Please select a color.');
                    return false;
                }
            }

            // Size
            if ($('.custom-ddlist').length > 0) {
                if ($('.custom-ddlist .custom-dropdown .selected span').html() === '') {
                    e.preventDefault();
                    displayUserFeedbackMessage('error', 'Size missing', 'Please select a size.');
                    return false;
                }
            }

            if ($('form.product-form .product-select--size select').length > 0) {
                if ($('.product-select--size select').val() == '') {
                    e.preventDefault();
                    displayUserFeedbackMessage('error', 'Size missing', 'Please select a size.');
                    return false;
                }
            }

            if ($('form.product-form #infiniteoptions-container').html().length > 0) {
                if ($('.spb-select select').val() == '') {
                    e.preventDefault();
                    $('#infiniteoptions-container').addClass('select-error');
                    displayUserFeedbackMessage('error', 'Size missing', 'Please select a size.');
                    return false;
                }
            }

            // Dress length
            if ($('form.product-form .product-select--dress-length select').length > 0) {
                if ($('.product-select--dress-length select').val() == '') {
                    e.preventDefault();
                    displayUserFeedbackMessage('error', 'Dress Length missing', 'Please select a length.');
                    return false;
                }
            }
        });

        // When InfiniteOptions Select appears apply some logic
        document.arrive(".infinite-option-size-select select", function () {
            if (product_is_ready_to_ship == 'true' && product_type == 'dress') {
                $(this).prop('disabled', true);
            } else {
                if (selected_options.color != '') {
                    $(this).prop('disabled', false);
                }

                if (selected_options.dress_size != '') {
                    $(this).val(selected_options.dress_size);
                    $(this).prop('disabled', false);
                }
            }

            handleEnableAddToCart();
        });

        // Handle Variant options Change events
        // Store selections in SessionStorage and check Add to Cart State
        $(document).on('change', '.infinite-option-size-select select', function () {
            if (document.readyState == "complete") {
                if ($(this).val() != '') {
                    $('#infiniteoptions-container').removeClass('select-error');
                }

                selected_options.dress_size = $(this).val();
                sessionStorage.setItem("selected_options", JSON.stringify(selected_options));
                handleEnableAddToCart();
            }
        });

        $(document).on('change', '.product-select--size select', function () {
            if (document.readyState == "complete") {
                selected_options.dress_size = $(this).val();
                sessionStorage.setItem("selected_options", JSON.stringify(selected_options));
                handleEnableAddToCart();
            }
        });

        $(document).on('change', '.product-select--dress-length select', function () {
            if (document.readyState == "complete") {
                selected_options.dress_length = $(this).val();
                sessionStorage.setItem("selected_options", JSON.stringify(selected_options));
                handleEnableAddToCart();
            }
        });

        // Custom Ready-to-Ship Dropdown Events
        // Show options on dropdown click
        const custom_select = $('.custom-dropdown .selected');
        const down_arrow = $('.custom-dropdown .selected svg');
        custom_select.on('click keypress', function (e) {
            // Utiliser la méthode css() de jQuery pour obtenir la valeur de display
            // ou accéder au DOM element et vérifier si l'élément est visible
            const dropdown = $(this).next();

            if (dropdown.is(':visible')) {
                dropdown.hide();
                down_arrow.removeClass('active');
            } else {
                dropdown.show();
                down_arrow.addClass('active');
            }
        });
        // Hide Options on outside click or ESC keypress
        $(document).bind('click', function (e) {
            var $clicked = $(e.target);
            if (!$clicked.parents().hasClass("custom-dropdown")) {
                custom_select.next().hide();
            }
        });

        $(document).on('keyup', function (evt) {
            if (evt.keyCode == 27) {
                custom_select.next().hide();
            }
        });


        // Custom dropdown Option click Handler
        $(document).on('click keypress', '.custom-dropdown .ddlist-options ul li', function () {

            $('.custom-dropdown .ddlist-options ul li').removeClass('active-selection');
            const AddToCartButton = $('button.product-form__cart-submit');
            const klaviyoButton = $('button.klaviyo_popup_trigger');
            if (!$(this).hasClass('disabled')) {
                // Set Estimated Delivery Date value
                $(this).addClass('active-selection');
                const hidden_eta_input = $('#hidden-product-estimated-date');
                const hidden_saletype = $('input[type=hidden]#product-properties-saletype');
                const eta_date_element = $('.estimated-delivery-date p#delivery_service_desc');
                const is_holiday = $('.estimated-delivery-date.is-holiday-date').length > 0;
                const is_pre_order = $('input[type=hidden]#hidden-is-preorder').val();

                if ($(this).hasClass('rts')) {

                    if (is_pre_order) {
                        hidden_saletype.val('Preorder');
                    } else {
                        hidden_eta_input.val(eta_date_element.data().instockDate);
                        hidden_saletype.val('In Stock');
                        AddToCartButton.show();  // Cache le bouton "Add to Cart"
                        klaviyoButton.hide();
                    }
                } else {
                    if ($(this).hasClass('rtw')) {
                        AddToCartButton.hide();  // Cache le bouton "Add to Cart"
                        klaviyoButton.show();
                    }
                    if (!is_holiday) {
                        hidden_eta_input.val(eta_date_element.data().mtoDate);
                    } else {
                        hidden_eta_input.val(eta_date_element.data().holidayDate);
                    }
                    hidden_saletype.val('Made to Order');
                }

                // Set Custom dropdown Selected Value and hide Options
                custom_select.find('span.current-selected-value').text($(this).find('span.variant-value').text());
                custom_select.next().hide();
                // Select Size in hidden dropdown and trigger Select Change
                $('.product-select--size select').val($(this).find('span.variant-value').text()).change();
                // Set Selected Variant from Hidden Select
                $('.product-form__variants').val($(this).data('variant-id'));
                // Update URL Param
                let url = new URL(window.location.href);
                url.searchParams.set('variant', $(this).data('variant-id'));
                window.history.replaceState(null, null, url);
            }
        });


        if ($('.product-select--RTS').length > 0) {
            const product_id = $('.custom-dropdown .ddlist-options ul').data('product-id');
            if (product_id) {
                const active_swatch = $('.swatch-element.active-swatch');
                let active_color = null;

                if (active_swatch.length > 0) {
                    active_color = active_swatch.attr('data-colorname-value');
                    if (active_color) {
                        active_color = active_color.toLowerCase(); // Ensure it's safe to use .toLowerCase()
                    }
                }

                const api_endpoint = `https://api.ecom.amsale.com/api/inventory/${product_id}`;

                // Fetch inventory data
                $.ajax({
                    type: "GET",
                    url: api_endpoint,
                    dataType: "json",
                    success: function (data, textStatus) {
                        if (textStatus === "success" && data && data.inventory && data.inventory.length > 0) {
                            if (is_rtw === "true" && active_color) {
                                fetchProductAndInventoryData(active_color);
                                generateDropdownHTML(data.inventory, null, active_color);
                            } else {
                                generateDropdownHTML(data.inventory);
                            }

                        } else {
                            console.warn("No valid inventory data received.");
                        }
                    },
                    error: function () {
                        displayUserFeedbackMessage("error", "Error", "Sorry. An error occurred.<br>Please refresh the page<br>and try again.");
                    }
                });
            }
        }

    }
});

// Set mobile slider dot active state
function setSliderDotActive(goToIndex) {
    const active_index = parseInt($('.slider-dot.active').data('slide-index'));
    $('.slider-dot').eq(active_index).removeClass('active');
    $('.slider-dot').eq(goToIndex).addClass('active');
}


function setSwatchSelectValue(value) {
    $('.product-select--color select.single-option-selector').val(capitalizeFirstLetters(value)).trigger('change');
}

function capitalizeFirstLetters(str) {
    return str.split('-').map(function (item) {
        return item.charAt(0).toUpperCase() + item.slice(1)
    }).join('-');
}

// Handle Add to Cart Button Disable State
function handleEnableAddToCart() {
    //$('button.product-form__cart-submit').prop('disabled', true);
    const size_select = $('.infinite-option-size-select select').length > 0 ? $('.infinite-option-size-select select') : $('.product-select--size select');
    const length_select = $('.product-select--dress-length select');
    const swatch_selectors = $('.colorSelector');
    const collectionName = $('input[type=hidden]#hidden-product-collection').val();
    let valid_state = false;

    if (swatch_selectors.length == 0 && size_select.length == 0 && length_select.length == 0) {
        valid_state = true;
    } else if (swatch_selectors.length > 0 && size_select.length == 0 && length_select.length == 0) {
        if (swatch_selectors.find('.active-swatch').length > 0) {
            valid_state = true;
        }
    } else if (swatch_selectors.length > 0 && size_select.length > 0 && length_select.length > 0) {
        if (swatch_selectors.find('.active-swatch').length > 0 && size_select.val() != '' && length_select.val() != '') {
            valid_state = true;

        }
    } else if (swatch_selectors.length > 0 && size_select.length > 0 && length_select.length == 0) {
        if (swatch_selectors.find('.active-swatch').length > 0 && size_select.val() != '') {
            valid_state = true;

        }
    } else if (swatch_selectors.length == 0 && size_select.length > 0 && length_select.length == 0) {
        if (size_select.val() != '') {
            valid_state = true;
        }
    } else if (swatch_selectors.length == 0 && size_select.length > 0 && length_select.length > 0) {
        if (size_select.val() != '' && length_select.val() != '') {
            valid_state = true;
        }
    }

    if ($('.product__price dd span.price-item--regular').text().includes('Sold out') || $('button.product-form__cart-submit span').text().includes('Sold out')) {
        valid_state = true;
    }

    if (valid_state) {
        $('button.product-form__cart-submit').prop('disabled', false);
    } else if (!valid_state && collectionName === 'private-sale') {

        $('button.product-form__cart-submit').prop('disabled', true);
    }
}

// Return selected Color
function getCurrentColor() {
    let element = null;

    if ($('.colorSelector').length > 0) {
        element = $('.colorSelector');
    } else if ($('.product-form__selects.product-select--color').length > 0) {
        element = $('.product-form__selects.product-select--color');
    }

    if (element) {
        if (element.hasClass('colorSelector')) {
            return element.find('.active-swatch').attr('data-colorname-value');
        } else {
            return element.find('select.single-option-selector').val();
        }
    }

    return false;
}

function escapeRegExpMatch(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

function isExactMatch(str, match) {
    return new RegExp(`\\b${escapeRegExpMatch(match)}\\b`).test(str)
}

// On page load or reload if Session exists we set the proper variant ID
// If we don't cover this scenario, Add to cart will
// add the first selected variant from the list which is wrong
function setVariantID(dress_size, dress_length) {
    let full_search_query = '';

    if (getCurrentColor() !== false && dress_size !== '' && dress_length !== '') {
        if ($('.product-form__selects.product-select--size').length > 0) {
            full_search_query = `${getCurrentColor()} / ${dress_size} / ${dress_length}`;
        } else {
            full_search_query = `${getCurrentColor()} / ${dress_length}`;
        }
    } else if (getCurrentColor() !== false && dress_size == '' && dress_length !== '') {
        full_search_query = `${getCurrentColor()} / ${dress_length}`;
    } else if (getCurrentColor() !== false && dress_size !== '' && dress_length == '') {
        if ($('.product-form__selects.product-select--size').length > 0) {
            full_search_query = `${getCurrentColor()} / ${dress_size}`;
        } else {
            full_search_query = getCurrentColor();
        }
    } else if (getCurrentColor() !== false && dress_size == '' && dress_length == '') {
        full_search_query = getCurrentColor();
    } else if (getCurrentColor() == false && dress_size !== '') {
        full_search_query = dress_size;
    }

    if (full_search_query !== '') {
        $('select.product-form__variants option').each(function () {
            if (isExactMatch(full_search_query, $(this).text())) {
                $('select.product-form__variants').val($(this).val());
            }
        });
    }
}

function setGlobalSkuOnClick(sku) {
    if ($('#hidden-is-rtw').val()) {
        $('#hidden-product-sku').val(sku)
    }
}

function generateDropdownHTML(inventoryData, productData = null, selectedColor = null) {
    if (!inventoryData || inventoryData.length === 0) {
        console.warn("⚠ No inventory data found!");
        return;
    }
    const is_pre_order = $('input[type=hidden]#hidden-is-preorder').val();
    const custom_ddl = $('.custom-dropdown .ddlist-options ul');
    const soldout = custom_ddl.data('sold-out');
    const rtw = productData?.product?.template_suffix
    let DDL_html = "";
    let addedSizes = new Set();

    inventoryData.forEach(item => {
        const { variant_id, available, size, location } = item;
        if (["XL", "SS", "MM"].includes(size) || !location?.includes('318')) {
            return;
        }

        let matching_variant = productData
            ? productData.product.variants.find(v => v.id == variant_id)
            : null;

        if (selectedColor && (!matching_variant || matching_variant.option1.toLowerCase() !== selectedColor.toLowerCase())) {
            return;
        }

        let color = matching_variant ? matching_variant.option1 : "Unknown";
        let listItemClass = available ? "option rts" : soldout && rtw ? "option rtw" : "option mto";
        let statusText = available ? (is_pre_order ? "Pre Order" : "In Stock") : soldout ? "Sold Out" : "Made to Order";
        if (listItemClass == "option rtw" || listItemClass == "option rts" && rtw) {
            statusText = "";
        }


        let sizeKey = `${size}-${color}`;

        if (!addedSizes.has(sizeKey)) {
            DDL_html += `
                <li class="${listItemClass}" role="option" tabindex="0" 
                    data-variant-id="${variant_id}" data-color="${color}" onclick="setGlobalSkuOnClick('${matching_variant?.sku}')">
                    <span class="variant-value">${size}</span>
                    <span>${statusText}</span>
                </li>
            `;
            addedSizes.add(sizeKey);
        }
    });

    custom_ddl.html(DDL_html);
    $('.custom-dropdown span.loading-data').removeClass('loading');
}

function fetchProductAndInventoryData(selectedColor = null) {
    const product_id = $('.custom-dropdown .ddlist-options ul').data('product-id');
    if (!product_id) {
        console.error("Error: Product ID not found!");
        return;
    }

    const productHandle = window.location.pathname.split('/').pop();
    const productUrl = `/products/${productHandle}.json`;
    const inventoryUrl = `https://api.ecom.amsale.com/api/inventory/${product_id}`;

    Promise.all([
        fetch(productUrl).then(res => res.json()).catch(err => console.error("❌ Error fetching product data:", err)),
        fetch(inventoryUrl).then(res => res.json()).catch(err => console.error("❌ Error fetching inventory data:", err))
    ]).then(([productData, inventoryData]) => {

        if (!productData?.product?.variants) {
            console.error("Invalid productData format!", productData);
            return;
        }

        const inventoryArray = inventoryData.inventory;
        if (!Array.isArray(inventoryArray)) {
            console.error("Extracted inventoryArray is not an array!", inventoryArray);
            return;
        }

        const variantLookup = new Set(productData.product.variants.map(variant => variant.id));

        if (selectedColor) {
            const matchingVariant = productData.product.variants.find(
                v => v.option1.toLowerCase() === selectedColor.toLowerCase()
            );

            if (!matchingVariant) {
                console.warn("⚠ No matching variant found for color:", selectedColor);
                return;
            }

            $("#hidden-variant-id").val(matchingVariant.id);

            const filteredInventory = inventoryArray.filter(
                item => variantLookup.has(item.variant_id)
            );

            const sizeDropdown = $('.product-select--size select');
            const customDropdownList = $('.custom-dropdown .ddlist-options ul');
            customDropdownList.empty();

            const addedSizes = new Set();

            if (filteredInventory.length > 0) {
                // Add an empty option at the beginning
                $('.current-selected-value').text('Select Size');
                filteredInventory.forEach(({ size, variant_id }) => {
                    if (!addedSizes.has(size)) {
                        addedSizes.add(size);
                        sizeDropdown.append(`<option value="${size}">${size}</option>`);
                        customDropdownList.append(
                            `<li role="option" tabindex="0" data-variant-id="${variant_id}" data-color="${selectedColor}">${size}</li>`
                        );
                    }
                });

                // Enable dropdowns only if sizes are available
                sizeDropdown.prop("disabled", false);
                $('.custom-dropdown .selected span').prop("disabled", false);
            } else {
                sizeDropdown.append('<option value="">No sizes available</option>');
                $('.custom-dropdown .selected span').styles.color = 'blue';
            }

            generateDropdownHTML(filteredInventory, productData, selectedColor);
            updateProductImages(matchingVariant.id, productData);

        } else {
            generateDropdownHTML(inventoryArray, productData);
        }
    }).catch(error => console.error("Error fetching data:", error));
}


function updateProductImages(variantId, productData) {
    if (!variantId || !productData) {
        console.error("Missing variantId or productData");
        return;
    }

    // Try to match variant from product data
    const matchingVariant = productData.product.variants.find(v => String(v.id) === String(variantId));
    if (!matchingVariant) {
        console.warn("No matching variant found in productData");
        return;
    }

    const selectedColor = matchingVariant.option1;

    // --- DESKTOP VERSION (> 992px) ---
    if ($(window).width() > 992) {
        // 1. D'abord, cacher toutes les vignettes qui ne correspondent pas à la couleur sélectionnée
        $('.thmb-slider .thmb').each(function () {
            const thumbColor = $(this).data('color');
            if (thumbColor === selectedColor.toLowerCase()) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });

        // 2. Cacher/afficher les slides dans le slider principal
        let firstVisibleSlide = null;
        let visibleCount = 0;

        $('.image-main .slide').each(function () {
            const slideColor = $(this).attr('data-color');
            if (slideColor === selectedColor) {
                $(this).show();
                visibleCount++;
                if (!firstVisibleSlide) {
                    firstVisibleSlide = $(this);
                }
            } else {
                $(this).hide();
            }
        });

        // 3. Réinitialiser la position du slider si nécessaire
        if (firstVisibleSlide && visibleCount > 0) {
            // Cliquer sur la première vignette visible pour synchroniser les deux sliders
            const firstVisibleThumb = $('.thmb-slider .thmb:visible').first();
            if (firstVisibleThumb.length) {
                setTimeout(function () {
                    firstVisibleThumb.trigger('click');
                }, 100);
            }
        } else {
            console.warn('Aucune image trouvée pour la couleur:', selectedColor);
        }
    }
    // --- MOBILE VERSION (≤ 992px) ---
    else {
        // Pour mobile, nous avons besoin de reconstruire le slider
        // 1. Trouver toutes les images correspondant à la couleur
        const matchingSlides = [];

        $('.image-main .slide').each(function (index) {
            const slideColor = $(this).attr('data-color');
            if (slideColor === selectedColor) {
                matchingSlides.push({
                    slide: $(this),
                    index: index
                });
            }
        });

        // 2. Si des diapositives correspondantes sont trouvées, naviguer vers la première
        if (matchingSlides.length > 0) {
            const firstIndex = matchingSlides[0].index;

            // Vérifier si les sliders sont initialisés
            if ($('.slider-main').hasClass('slick-initialized')) {
                console.log('Reconstruction du slider pour la couleur:', selectedColor);
                // Détruire et reconstruire le slider pour éviter les problèmes d'index
                $('.slider-main').slick('unslick');

                // Cacher les slides qui ne correspondent pas
                $('.image-main .slide').each(function () {
                    console.log($(this).attr('data-color'), selectedColor);
                    const slideColor = $(this).attr('data-color');
                    $(this).toggle(slideColor === selectedColor);
                });

                // Réinitialiser le slider
                $('.slider-main').slick(slickOptionsProductMain);

                // Naviguer vers la première diapositive
                setTimeout(function () {
                    $('.slider-main').slick('slickGoTo', 0, true);
                }, 100);
            }

            if ($('.image-main').hasClass('slick-initialized')) {
                // Même processus pour image-main
                $('.image-main').slick('unslick');

                // Cacher les slides qui ne correspondent pas
                $('.image-main .slide').each(function () {
                    const slideColor = $(this).attr('data-color');
                    $(this).toggle(slideColor === selectedColor);
                });

                // Réinitialiser le slider
                $('.image-main').slick(slickOptionsMain);

                // Naviguer vers la première diapositive
                setTimeout(function () {
                    $('.image-main').slick('slickGoTo', 0, true);
                }, 100);
            }
        } else {
            console.warn('Aucune image trouvée pour la couleur:', selectedColor);
        }
    }
}

function setHiddenFieldValues() {
    const current_sku = $('input[type=hidden]#hidden-product-sku').val();
    const eta_date_element = $('.estimated-delivery-date p#delivery_service_desc');
    const hidden_eta_input = $('#hidden-product-estimated-date');
    const session_exists = sessionStorage.getItem("selected_options");
    const is_holiday = $('.estimated-delivery-date.is-holiday-date').length > 0;
    if (session_exists && (current_sku == JSON.parse(session_exists).sku)) {
        current_dress_size = JSON.parse(session_exists).dress_size;

        const custom_options = $('.custom-dropdown .ddlist-options ul li');
        custom_options.each(function (index) {
            if ($(this).find('span.variant-value').text() === current_dress_size) {
                if ($(this).hasClass('mto')) {
                    if (!is_holiday) {
                        hidden_eta_input.val(eta_date_element.data().mtoDate);
                    } else {
                        hidden_eta_input.val(eta_date_element.data().holidayDate);
                    }
                    $('input[type=hidden]#product-properties-saletype').val('Made to Order');
                } else {
                    $('input[type=hidden]#product-properties-saletype').val('In Stock');
                    hidden_eta_input.val(eta_date_element.data().instockDate);
                }
            }
        })
    }
}

document.querySelectorAll('.detailBox .content a').forEach(link => {
    const text = link.textContent.trim().toLowerCase();

    let is_boldmetrics = ($('input[type=hidden]#hidden-product-boldmetrics-enabled').val() === 'true');

    if (text.includes('size guide')) {
        link.classList.add('size-chart-link-popup')
        link.href = '#size-guide';
        link.addEventListener('click', e => {
            e.preventDefault();
            $('size-chart-link-popup').magnificPopup({
                type: 'inline',
                midClick: true
            });
        })
    }

    if (text.includes('fit check tool')) {
        link.classList.add('fit-link-modal')
        link.href = '#fit-check-tool';

        link.addEventListener('click', e => {
            e.preventDefault();
            $('.boldmetrics-ssc-button, #ssc-boldmetrics-activator').click();
            return false;
        });
    }
    if (text.includes('measure')) {
        link.href = 'https://amsale.com/blogs/amsale/how-to-measure-your-dress-size';
        link.target = '_blank';
    }
});
